export default "__VITE_ASSET__pJ0UrrBk__"